import { $ } from 'utils'
import moment from 'moment'
import { Tooltip } from 'components'

const Date = ({ value }) =>
  $(Tooltip, {tip: moment(value, 'DD/MM/YYYY HH:mm:ss').format('DD MMMM YYYY [at] HH:mm:ss')},
    moment(value, 'DD/MM/YYYY HH:mm:ss').calendar()
  )

export default Date



// WEBPACK FOOTER //
// ./src/components/Date.js